import isEmpty from 'lodash/isEmpty';
import { asGlobalResourceQuery } from 'v5/api/_common/query/workspace-scoping';
import type { ResourceQuery } from 'v5/api/resource/resource.api';
import { resourceSearchOfV1 } from 'v5/core/resource-search/v1ResourceSearch';

interface BestMatchesSlot {
  query?: unknown;
  is_location?: boolean;
}

interface BookingStatus {
  id: number;
  status_type?: string;
}

// the server's page when a request names none, which is what this list always got
const page = { page: 0, pageSize: 50 };

/**
 * A role's best matches: its saved search, people booked in any status but an unavailable one
 * over the production first, by status. Locations by name, booked or not. Null without a search.
 */
export function bestMatchesQuery(
  slot: BestMatchesSlot,
  bookingStatuses: BookingStatus[],
  startDate: string,
  endDate: string
): ResourceQuery | null {
  if (isEmpty(slot.query)) return null;
  const { query } = resourceSearchOfV1(slot.query);
  if (slot.is_location) {
    return asGlobalResourceQuery({
      ...query,
      page,
      sort: { field: 'full_name', order: 'asc' }
    });
  }
  return asGlobalResourceQuery({
    ...query,
    page,
    sort: { field: 'availability', order: 'asc' },
    booked: {
      startDate,
      endDate,
      statusIds: bookingStatuses
        .filter(status => status.status_type !== 'UNAVAILABLE')
        .map(status => status.id)
    }
  });
}
